import React, { useEffect } from 'react';
import { Scroll, closest, each } from 'helpers';
import { mount } from './mount';
import { section } from 'styles/common.scss';

export const AnchorsLinks = mount('app-anchors-links', props => {
  useEffect(() => {
    each(window.document.querySelectorAll('a[href^="#"]'), link => {
      link.addEventListener('click', onLinkClick);
    })
  }, [])
  return null;
});

const scroller = new Scroll({
  duration: 300,
  header: '#wpadminbar',
});

function onLinkClick(event) {
  event.preventDefault();
  const target = window.document.querySelector(event.target.getAttribute('href'));
  if (target) {
    const marginTop = parseInt(getComputedStyle(target).marginTop);
    const parentSection = closest(target, `.${section}`);
    const paddingTop = parseInt(getComputedStyle(parentSection).paddingTop);
    scroller.toElement(target, {
      offset: -1*(marginTop || paddingTop)
    });
  }
}
